import { createFileRoute, redirect } from '@tanstack/react-router';
import { DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH } from '../../../../../../../../features/generate/trade-confirmation/job/docgen-trade-confirm-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/')({
  beforeLoad: () => {
    throw redirect({ to: DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH });
  },
  preload: false,
});
